import classNames from 'classnames';
import React from 'react';
import './TableRow.scss';
import ITableRowProps from './TableRowProps';

function TableRow<RowType>({ row, onClick, disabled, className, children }: ITableRowProps<RowType>) {
  const classes = classNames(
    {
      'table-row': true,
      'table-row-clickable': onClick,
    },
    className
  );

  function handleClick(event: React.MouseEvent) {
    if (!disabled && onClick) {
      onClick(row, event);
    }
  }

  return (
    <tr className={classes} onClick={handleClick}>
      {children}
    </tr>
  );
}

TableRow.defaultProps = {
  row: {},
};

export default TableRow;
